import React, { useEffect } from "react"
import { Link } from "gatsby"
import { Col } from "react-bootstrap"

import { formatDateForCvExpiry } from "../../utils/format-date-time"
import Tick from "../../images/icons/wdn-tick.svg"

const CardButton = ({
  isInCart,
  state,
  handleShortlistDelete,
  handleCartDelete,
  handleAddToCart,
  isShortlisted,
  handleShortlist,
  loading,
  candidate,
  displayShortlistButton,
  displayCartDeleteButton,
  displayShortlistDeleteButton,
  displayCartButtton,
  displayViewProfileButton,
  displayPaidCvsDeleteButton,
  page,
  handlePaidCvsDelete,
}) => {
  useEffect(() => {}, [isInCart, isShortlisted])
  return (
    <>
      {displayViewProfileButton && (
        <Col xs="12 mb-2">
          <Link to={"/candidate/detail/" + candidate.username}>
            <button
              className={
                isInCart
                  ? "blue-background btn btn-small blue-outline hover-blue rounded my-1"
                  : "btn btn-small blue-outline hover-blue rounded my-1"
              }
            >
              View Profile
            </button>
          </Link>
        </Col>
      )}
      {displayShortlistDeleteButton && (
        <Col xs="12 mb-2">
          <button
            onClick={handleShortlistDelete}
            className={"btn btn-small btn-custom rounded btn-danger "}
          >
            Delete
          </button>
        </Col>
      )}
      {state?.isAuthenticated &&
        displayCartButtton &&
        candidate.profile.experience !== "Fresher" && (
          <Col xs="12 mb-2">
            <button
              disabled={loading || isInCart}
              onClick={handleAddToCart}
              className={
                isInCart
                  ? " btn btn-small blue-outline rounded my-1"
                  : "btn btn-small blue-outline  rounded my-1"
              }
            >
              {isInCart ? (
                <>
                  <img src={Tick} className="img-fluid mb-1" alt="" />
                  <span className="ml-2">In Cart</span>
                </>
              ) : (
                " Add CV to Cart"
              )}
            </button>
          </Col>
        )}
      {displayCartDeleteButton && (
        <Col xs="12 mb-2">
          <button
            onClick={handleCartDelete}
            className={"btn btn-small btn-custom rounded btn-danger "}
          >
            Delete
          </button>
        </Col>
      )}
      {displayPaidCvsDeleteButton && (
        <Col xs="12 mb-2">
          <button
            onClick={handlePaidCvsDelete}
            className={"btn btn-small btn-custom rounded btn-danger "}
          >
            Delete
          </button>
        </Col>
      )}
      {displayShortlistButton && !state?.isAuthenticated ? (
        <Col xs="12 mb-2">
          <button
            className={
              isShortlisted
                ? "btn btn-small background-grey rounded my-1"
                : "btn btn-small grey rounded my-1"
            }
            disabled={loading || isShortlisted}
            onClick={handleShortlist}
          >
            Login to continue
          </button>
        </Col>
      ) : (
        <Col xs="12 mb-2">
          <button
            className={
              isShortlisted
                ? "btn btn-small background-grey rounded my-1"
                : "btn btn-small grey rounded my-1"
            }
            disabled={loading || isShortlisted}
            onClick={handleShortlist}
          >
            {isShortlisted ? (
              <>
                <img
                  src={Tick}
                  height={"100px"}
                  width={"100px"}
                  className="mb-1"
                  alt=""
                />
                <span className="ml-2">Shortlisted</span>
              </>
            ) : (
              "Shortlist"
            )}
          </button>
        </Col>
      )}
      {page === "paid-cvs" && candidate.visible_upto && (
        <Col xs="12" className="text-md-right text-center mt-2">
          <div className="purchased_date">
            Visible Upto:{" "}
            {candidate.visible_upto &&
              formatDateForCvExpiry(candidate.visible_upto)}
            <br /> ({" "}
            <span className="blue-text">{candidate.remaining_days} days</span>{" "}
            remaining )
          </div>
        </Col>
      )}
    </>
  )
}

export default CardButton
